import React, {useState} from 'react';
import './ExpenseItem.css';
import ExpenseDate from './ExpenseDate';
import Card from '../UI/Card';

export default function ExpenseItem(props) {
    
    // const expenseTitle = props.title;
    // const [expenseTitle, setTitle] = useState(props.title);
    // const [expenseAmount, setAmount] = useState(props.amount);
    const expenseAmount = props.amount;
    const expenseTitle = props.title;
    // const clickHandler = () => {
    //   setTitle('Updated!');
    // };
    // const backclickHandler = () => {
    //   setTitle(props.title);
    // };
  return (
      <Card className='expense-item'>
        <ExpenseDate date={props.date} />
          <div className='expense-item__description'>
            <h2>{expenseTitle}</h2>
            <div className='expense-item__price'>${expenseAmount}</div>
          </div>
          {/* <button onClick={clickHandler}>Clicked</button>
          <button onClick={backclickHandler}>BackClicked</button> */}
      </Card>
  );
}
